import { render, staticRenderFns } from "./StaticTemplate.vue?vue&type=template&id=341ca922&scoped=true&"
import script from "./StaticTemplate.vue?vue&type=script&lang=js&"
export * from "./StaticTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StaticTemplate.vue?vue&type=style&index=0&id=341ca922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341ca922",
  null
  
)

export default component.exports